//
// Module for the Generate Correspondence page.
//
rs.module("framework/content/correspondence/generatecorrespondence",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, actions, deliveryMethods, deliveryDefaults) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var previewBtn = form.js(jsSelectors.previewBtn, { required: false });
            var reviewBtn = form.js(jsSelectors.reviewBtn);
            var distributeBtn = form.js(jsSelectors.distributeBtn);
            var action = form.js(jsSelectors.action);
            var deliveryMethod = form.js(jsSelectors.deliveryMethod);
            var previewSection = form.js(jsSelectors.previewSection, { required: false });
            var distributeSection = form.js(jsSelectors.distributeSection);
            var saveForReviewSection = form.js(jsSelectors.saveForReviewSection);
            var emailIndicator = form.js(jsSelectors.emailIndicator, { multiple: true });
            var printIndicator = form.js(jsSelectors.printIndicator, { multiple: true });
            var printerSelect = form.js(jsSelectors.printerSelect);
            var emailAddressInput = form.js(jsSelectors.emailAddressInput);

            // Get select helper(s)
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Selected action has changed
            action.on("change", function () {

                var selectedAction = $(this).val();

                // Toggle visibility of the sections based on the chosen value
                visibility.setVisible(previewBtn, selectedAction == actions.Preview);
                visibility.setVisible(distributeBtn, selectedAction == actions.Distribute);
                visibility.setVisible(reviewBtn, selectedAction == actions.SaveForReview);

                visibility.setVisible(previewSection, selectedAction == actions.Preview);
                visibility.setVisible(distributeSection, selectedAction == actions.Distribute);
                visibility.setVisible(saveForReviewSection, selectedAction == actions.SaveForReview);
            });

            // Delivery method (Email or Print) has changed 
            deliveryMethod.on("change", function () {

                var deliveryValue = $(this).val();

                // Identify selected distribution
                var isEmail = (deliveryValue & deliveryMethods.email) == deliveryMethods.email;
                var isPrint = (deliveryValue & deliveryMethods.print) == deliveryMethods.print;
                var isDefault = (deliveryValue & deliveryMethods.defaultDeliveryMethod) == deliveryMethods.defaultDeliveryMethod;

                // Show/hide the email/print fields based on delivery method chosen.
                visibility.setVisible(emailIndicator, isEmail);
                visibility.setVisible(printIndicator, isPrint);

                // If default delivery method is selected, set the default field and disable.
                if (isDefault) {

                    if (isEmail) {
                        emailAddressInput.val(deliveryDefaults.emailAddress).prop('disabled', true);
                    }
                    else if (isPrint) {
                        printerSelectHelper.setValue(deliveryDefaults.printer);
                    }
                }
                else {
                    // re-enable fields.
                    emailAddressInput.prop('disabled', false);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);